import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { ExtensionModuleAction } from '@atlaskit/editor-common/extensions';

import type { Snippet } from '../services/snippetApi';

function filterValidAdfNodes(nodes: (ADFEntity | null | undefined)[]): ADFEntity[] {
	return nodes.filter((node): node is ADFEntity => node !== undefined && node !== null);
}

export const snippetQuickInsertAction = (snippet: Snippet): ExtensionModuleAction => {
	return async () => {
		try {
			const parsedContent = JSON.parse(snippet.content);

			// Handle fragment (array of nodes without doc wrapper)
			if (Array.isArray(parsedContent)) {
				return filterValidAdfNodes(parsedContent);
			}

			// Handle single node or doc node
			const adfContent = parsedContent as ADFEntity;

			if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) {
				return filterValidAdfNodes(adfContent.content);
			}

			return adfContent;
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error processing snippet ADF:', error);
			return undefined;
		}
	};
};
